import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { forkJoin } from 'rxjs';
import { ExcelService } from 'src/app/services/excel.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NotificationService } from 'src/app/services/notification-service';
import { SearchHistoryService } from 'src/app/services/search-history.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-searchhistory',
    templateUrl: './searchhistory.component.html',
    styleUrls: ['./searchhistory.component.scss']
})
export class SearchhistoryComponent implements OnInit {
    searchHistoryForm: FormGroup
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    toMinDate: Date;
    toMaxDate: Date;
    serviceQueue: any = []
    tempcoverageStatusList: any = [];
    temporderStatusList: any = [];
    coverageStatusList: any = []
    orderStatusList: any = []
    searchHistoryList: any = [];
    filteredList1: any = [];
    filteredList2: any = [];
    displayedColumns: string[] = [
        'Address',
        'IpAddress',
        'CustomerEmail',
        'SearchedOn',
        'CoverageStatus',
        'OrderStatus'
    ];
    dataExcel: any = [];
    data = [];
    dataSource = new MatTableDataSource(this.data);
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    excelColumns: string[];
    constructor(private fb: FormBuilder, private lookupDataService: LookupDataServiceService, private searchHistoryService: SearchHistoryService, private loaderService: LoaderService, private toastr: NotificationService,
        private excelService: ExcelService
    ) { }

    ngOnInit(): void {
        this.init()
        this.loadServiceQueue()
        this.executeServiceQueue()
        this.getTableData('')
    }
    init() {
        this.searchHistoryForm = this.fb.group({
            startDate: [null,],
            endDate: [null,],
            orderStatusType: [null, Validators.required],
            coverageStatusType: [null, Validators.required]
        });
    }
    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.searchHistoryForm.controls["startDate"].value;
        // this.toMaxDate = this.addMonths(this.toMinDate, 3);
    }
    loadServiceQueue() {
        this.serviceQueue.push(this.lookupDataService.getCoverageStatus());
        this.serviceQueue.push(this.lookupDataService.getOrderStatus());
    }
    executeServiceQueue() {
        forkJoin(this.serviceQueue).subscribe((serviceResponse) => {
            this.tempcoverageStatusList = serviceResponse[0];
            this.temporderStatusList = serviceResponse[1];
            this.tempcoverageStatusList.forEach(item => {
                if (item.key == 1 || item.key == 2) {
                    this.coverageStatusList.push(item);
                    this.coverageStatusList = this.coverageStatusList.sort((a, b) => a.value.localeCompare(b.value));
                    this.filteredList1 = this.coverageStatusList.slice()

                }
            })
            this.temporderStatusList.forEach(item => {
                if (item.key == 1 || item.key == 2) {
                    this.orderStatusList.push(item)
                    this.filteredList2 = this.orderStatusList.sort((a, b) => a.value.localeCompare(b.value));
                    this.filteredList2 = this.orderStatusList.slice()
                }
            });
        });
    }

    getTableData(date) {
        // data = { searchQuery: data }
        this.searchHistoryService.getSearchHistory(date).subscribe((res) => {
            this.data = [];
            this.dataExcel = [];
            this.data = res;
            this.dataExcel = res;
            this.dataSource = new MatTableDataSource(this.data);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        });
    }


    Reset() {
        this.searchHistoryForm.reset()
        this.getTableData('')
    }
    getRow(item) {
        return [
            item.searchQuery,
            item.queriedIPAddress,
            item.creationUserId,
            item.searchedOn,
            item.coverageStatusTypeName,
            item.orderStatusTypeName,
        ];
    }
    search() {
        debugger
        if (!this.searchHistoryForm.value.startDate && !this.searchHistoryForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date and To date should not be empty',
                position: 'center',

            })
        }
        else if (!this.searchHistoryForm.value.startDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date should not be empty',
                position: 'center',

            })
        }
        else if (!this.searchHistoryForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'End date should not be empty',
                position: 'center',

            })
        }
        else if (this.searchHistoryForm.value.startDate > this.searchHistoryForm.value.endDate) {
            if (this.searchHistoryForm.value.endDate) {
                Swal.fire({
                    icon: 'warning',
                    title: 'End Date should be greater than Start Date',
                    position: 'center',
                })
            }
        }
        else {
            let formValues = this.searchHistoryForm.getRawValue();
            formValues.startDate = moment(formValues.startDate).format("YYYY/MM/DD");
            formValues.endDate = moment(formValues.endDate).format("YYYY/MM/DD");

            this.getTableData(formValues);
        }
    }
    EncryptCustomerEmail(cusEmail) {
        if (cusEmail !== null && cusEmail.length > 2) {
            var atIndex = cusEmail.indexOf('@');
            if (atIndex !== -1) {
                var resultingEmail = cusEmail.slice(0, atIndex);
                if (resultingEmail.length > 0)
                    resultingEmail = 'x'.repeat(resultingEmail.length) + '@' + cusEmail.slice(atIndex + 1);
                else
                    resultingEmail = cusEmail;
                return resultingEmail;
            }
            else {
                return "";
            }
        }
        else {
            return "";
        }
    }
    exportData(): void {
        this.loaderService.start();
        setTimeout(() => {
            var exportData = this.dataExcel;
            if (!exportData || exportData.length === 0) {
                this.toastr.showInfo("No data available to export");
                this.loaderService.hide();
                return;
            }
            const excelList = [];
            this.excelColumns = [
                'S.No',
                'Address',
                'IP Address',
                'Customer Email',
                'Searched On',
                'Coverage Status',
                'Order Status'
            ]
            exportData.forEach((a, index) => {
                excelList.push({
                    sno: ++index,
                    "address": a.address,
                    "queriedIPAddress": a.queriedIPAddress,
                    "creationUserId": this.EncryptCustomerEmail(a.creationUserId),
                    "searchedOn": a.searchedOn,
                    "coverageStatusTypeName": a.coverageStatusTypeName,
                    "orderStatusTypeName": a.orderStatusTypeName,
                });
            });
            this.excelService.exportAsExcelFile(excelList, "AddressSearchHistory_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
            this.loaderService.stop();
        }, 500);
    }
}

